// Header: menu mobilne (dropdown) + aktywny link po nawigacji SWUP (header żyje poza #container).
export default class HeaderGlobal {
    constructor() {
        this.root = document.getElementById('site-header');
        if (!this.root) return;

        this.btn = this.root.querySelector('.menu-toggle');
        this.panel = this.root.querySelector('#mobile-menu');

        this.onToggle = this.toggle.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onPageView = this.markActive.bind(this);
        this.onResize = () => { if (window.innerWidth > 980) this.close(); };

        if (this.btn && this.panel) {
            this.btn.addEventListener('click', this.onToggle);
            document.addEventListener('click', this.onDocClick);
            document.addEventListener('keydown', this.onKey);
            window.addEventListener('resize', this.onResize, { passive: true });
        }
        document.addEventListener('dekret:pageview', this.onPageView);
    }

    toggle() {
        this.btn.getAttribute('aria-expanded') === 'true' ? this.close() : this.open();
    }

    open() {
        this.panel.hidden = false;
        this.btn.setAttribute('aria-expanded', 'true');
    }

    close() {
        if (!this.panel) return;
        this.panel.hidden = true;
        this.btn?.setAttribute('aria-expanded', 'false');
    }

    onDocClick(e) {
        if (this.panel.hidden) return;
        if (e.target.closest('#mobile-menu a')) { this.close(); return; }
        if (!e.target.closest('#mobile-menu') && !e.target.closest('.menu-toggle')) this.close();
    }

    onKey(e) {
        if (e.key === 'Escape' && !this.panel.hidden) {
            this.close();
            this.btn.focus();
        }
    }

    norm(p) {
        return (p || '/').replace(/\/+$/, '') || '/';
    }

    // po nawigacji SPA przelicz podświetlenie linków (artykuły/kategorie → "Baza wiedzy")
    markActive() {
        const cur = this.norm(location.pathname);
        const nav = this.root.querySelector('.nav');
        const blog = nav && nav.dataset.blogUrl ? this.norm(new URL(nav.dataset.blogUrl, location.origin).pathname) : '';
        const inBlog = document.body.classList.contains('single-post') || document.body.classList.contains('category') || document.body.classList.contains('tag');

        this.root.querySelectorAll('.nav a, .mobile-menu a:not(.btn)').forEach(a => {
            let path;
            try { path = this.norm(new URL(a.getAttribute('href'), location.origin).pathname); } catch (e) { return; }
            const on = path === cur || (inBlog && blog && path === blog);
            a.classList.toggle('on', on);
            on ? a.setAttribute('aria-current', 'page') : a.removeAttribute('aria-current');
        });
        this.close();
    }

    destroy() {
        this.btn?.removeEventListener('click', this.onToggle);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('dekret:pageview', this.onPageView);
    }
}
